import { REFERENCES as type } from '@/store/types';
import References from '@/services/Api/Awards/References';

const state = {
  data: [],
  loading: false,
};

const mutations = {
  [type.LOADING](state, data) {
    state.loading = data;
  },
  [type.SET](state, data) {
    state.data = data;
  },
  [type.SET_ITEM](state, item) {
    const referenceIndex = state.data.findIndex((r) => r.id === item.id);
    state.data.items.splice(referenceIndex, 1, item);
  },
  [type.CLEAR]() {
    this.commit(type.SET, []);
  },
};

const actions = {
  fetchReferences({ commit }, params) {
    commit(type.LOADING, true);
    References.all(params).then((response) => {
      const { status, data } = response.data;
      if (status === 200) {
        commit(type.SET, data);
      }
    })
      .finally(() => {
        commit(type.LOADING, false);
      });
  },
  // eslint-disable-next-line no-unused-vars
  selectReference({ commit, state }, referenceId) {
    return References.select(referenceId).then((response) => {
      commit(type.SET_ITEM, response.data.data);
    });
  },
  // eslint-disable-next-line no-unused-vars
  unselectReference({ commit }, referenceId) {
    return References.unselect(referenceId).then((response) => {
      commit(type.SET_ITEM, response.data.data);
    });
  },
};

const getters = {
  hasReferences(state) {
    const items = state.data;
    return items?.length > 0;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
